__turbopack_context__.v({
  "brussels-airport": "BrusselsAirport-module-scss-module__ACReLa__brussels-airport",
  "bullet": "BrusselsAirport-module-scss-module__ACReLa__bullet",
  "bullets": "BrusselsAirport-module-scss-module__ACReLa__bullets",
  "how": "BrusselsAirport-module-scss-module__ACReLa__how",
  "platform": "BrusselsAirport-module-scss-module__ACReLa__platform",
  "section": "BrusselsAirport-module-scss-module__ACReLa__section",
  "sold-out": "BrusselsAirport-module-scss-module__ACReLa__sold-out",
  "stargate": "BrusselsAirport-module-scss-module__ACReLa__stargate",
  "stargate-section": "BrusselsAirport-module-scss-module__ACReLa__stargate-section",
  "step": "BrusselsAirport-module-scss-module__ACReLa__step",
  "steps": "BrusselsAirport-module-scss-module__ACReLa__steps",
  "v-centered-description": "BrusselsAirport-module-scss-module__ACReLa__v-centered-description",
  "why": "BrusselsAirport-module-scss-module__ACReLa__why",
});
